import { Flex, Text } from "@simplybusiness/mobius";

export type MonthlyPremiumProps = {
  installmentsAmount: string;
};

export const MonthlyPremium = ({ installmentsAmount }: MonthlyPremiumProps) => {
  return (
    <Flex alignItems="baseline" flexWrap="wrap" columnGap="xxs">
      <Text
        className="mobius-quote-card__pricing-primary-amount --is-uk"
        data-testid="installment-amount"
      >
        {installmentsAmount}
      </Text>
      <Text
        className="mobius-quote-card__pricing-period-suffix --is-uk"
        elementType="span"
        variant="small"
      >
        /&nbsp;month
      </Text>
    </Flex>
  );
};
